import React, { useRef, useCallback, useMemo } from 'react';

import { SideNavContent } from '@atlaskit/navigation-system/layout/side-nav';

import { SideNavigationContext } from '@confluence/page-layout-side-navigation-context/entry-points/SideNavigationContext.ts';

import { fg } from '@confluence/feature-gating';

export const SideNavigationContent = ({ children }) => {
	const sideNavRef = useRef<HTMLDivElement>(null);

	const handleScrollToTop = useCallback(() => {
		if (sideNavRef.current) {
			sideNavRef.current.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		} else {
			const sideNavElement = document.querySelector('[data-auto-scrollable="true"]'); //this needs a better selector this is too generic
			if (sideNavElement) {
				sideNavElement.scrollTo({
					top: 0,
					behavior: 'smooth',
				});
			}
		}
	}, [sideNavRef]);

	const contextValue = useMemo(
		() => ({ sideNavRef, handleScrollToTop }),
		[sideNavRef, handleScrollToTop],
	);

	return (
		<SideNavigationContext.Provider value={contextValue}>
			{fg('navx-global-side-nav-confluence') ? (
				children
			) : (
				<SideNavContent testId="side-navigation-content" ref={sideNavRef}>
					{children}
				</SideNavContent>
			)}
		</SideNavigationContext.Provider>
	);
};
